<template>
  <v-navigation-drawer :value="isDrawerOpen" :width="width" class="drawer__right-side" fixed right>
    <div class="resume">
      <v-row no-gutters :class="`resume__header ${$vuetify.breakpoint.mobile ? 'pa-3' : 'pa-8'}`">
        <v-col>
          <h3 class="text-left pt-1">
            {{ title ? title : $t('detailsModal.title') }}
          </h3>
        </v-col>
        <v-col v-if="items && items.length" cols="2" class="text-right mr-1">
          <v-menu bottom offset-y left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item v-for="(item, i) in items" :key="i" @click="item.action">
                <v-list-item-title :class="item.color ? `${item.color}--text` : ''">
                  <v-icon :color="item.color ? item.color : ''" small left>
                    {{ item.icon }}
                  </v-icon>
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
        <v-col cols="1" class="text-right">
          <v-btn @click="setIsDrawerOpen(false)" icon>
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <div class="resume__content px-8">
        <slot />
      </div>

      <div class="resume__footer pa-8" v-if="!isLoading && moreInfo">
        <v-btn @click="handleGoTo" elevation="0" outlined text block>
          {{ $t('detailsModal.moreDetails') }}
        </v-btn>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import router from '@/router'

export default {
  name: 'RightDrawer',

  props: {
    moreInfo: {
      required: false,
      default: true,
    },

    title: {
      required: false,
    },

    items: {
      required: false,
      type: Array
    },

    width: {
      required: false,
      default: 480,
    },
  },

  computed: {
    ...mapGetters(['isLoading', 'isDrawerOpen']),
  },

  methods: {
    ...mapMutations(['setIsDrawerOpen']),

    handleGoTo() {
      const route = router?.history?.current
      const current = route?.path
      const id = route?.query?.id

      const goTo = `${current}/${id ? id : ''}`

      router.push(goTo)
      this.setIsDrawerOpen(false)
    },
  },
}
</script>
